var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectTreemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80005 3.49981C2.80005 3.38935 2.88959 3.2998 3.00005 3.2998H8.00005H13C13.1105 3.2998 13.2 3.38935 13.2 3.4998V8.4998V13.4998C13.2 13.6103 13.1105 13.6998 13 13.6998H8.00005H3.00005C2.88959 13.6998 2.80005 13.6103 2.80005 13.4998V8.4998V3.49981Z",
    stroke: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3999 2.7998V8.4998",
    stroke: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80005 8.5V14.2",
    stroke: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 5L7.99995 5",
    stroke: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.2998L2.3 10.2998",
    stroke: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 2.7998V8.4998",
    stroke: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6001 8.5V14.2",
    stroke: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 6.7998L7.99995 6.7998",
    stroke: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.1001L2.3 12.1001",
    stroke: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTreemap);
export default __webpack_public_path__ + "static/media/Select_Treemap.420267185586601c780a203655056067.svg";
export { ForwardRef as ReactComponent };